import { getLoadingProcessorUrl } from 'app/utils/enviromentUtil';
import { useEffect, useState } from 'react';

export function SubscriptionLoadingProcessor({ children, codigoSuporte, userUUID, eventSourceConfig, connect }) {
  const [, setUuid] = useState();
  const [, setFilename] = useState();
  const [, setErrors] = useState();
  const [, setProgress] = useState();
  const [, setUrlBucket] = useState();
  const [, setFile] = useState();

  let processorEventSource;
  let processorEventSourceBoleto;

  const URL_LOADING_PROCESSOR_SUBSCRIBE = `${getLoadingProcessorUrl()}/api/loading/subscribe`;

  const closeEventSources = () => {
    if (processorEventSource && processorEventSource.readyState === 1) {
      processorEventSource.close();
    }
    if (processorEventSourceBoleto && processorEventSourceBoleto.readyState === 1) {
      processorEventSourceBoleto.close();
    }
  };

  const handleProcessorOnOpen = (e) => {};

  const handleProcessorOnError = (e) => {
    processorEventSource.close();
  };

  /*const handleProcessorBoletoOnError = (e) => {
    processorEventSourceBoleto.close();
  };*/

  const handleProcessorOnUser = (e) => {
    if (!e.data) {
      return;
    }

    const data = JSON.parse(e.data);
    console.log(e.data);

    if (parseInt(data.porcentagem) === -1) {
      setUuid(data.uuid);
      setFilename(data.filename);
      setErrors(data.errors);
      setProgress(-1);
    } else {
      setUuid(data.uuid);
      setFilename(data.filename);
      setProgress(parseFloat(data.porcentagem));
      setFile(data.outputStream);
      setUrlBucket(data.urlBucket);
      // document.dispatchEvent(new Event('onToastrProcessorBorderoSuccess'));
    }
  };

  const subscriptionEmitter = () => {
    // Subscription Genérica
    processorEventSource = new EventSource(`${URL_LOADING_PROCESSOR_SUBSCRIBE}/${codigoSuporte}`);
    processorEventSource.addEventListener('open', handleProcessorOnOpen, false);
    processorEventSource.addEventListener('error', handleProcessorOnError, false);
    processorEventSource.onmessage = eventSourceConfig.onmessage;
    processorEventSource.onerror = eventSourceConfig.onerror;

    // Subscription Boleto
    // processorEventSourceBoleto = new EventSource(`${URL_LOADING_PROCESSOR_SUBSCRIBE}/${codigoSuporte}-BOLETO`);
    // processorEventSourceBoleto.addEventListener('open', handleProcessorOnOpen, false);
    // processorEventSourceBoleto.addEventListener('error', handleProcessorBoletoOnError, false);
    // processorEventSource.onmessage = boletoEventSourceOnMessage;

    if (userUUID) {
      processorEventSource.addEventListener(`${userUUID}`, handleProcessorOnUser, false);
      processorEventSourceBoleto.addEventListener(`${userUUID}`, handleProcessorOnUser, false);
    }
  };

  useEffect(() => {
    if (connect) {
      subscriptionEmitter();
    } else {
      closeEventSources();
    }
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connect]);
  return children;
}
